import { TextField } from "@mui/material";
import { Autocomplete } from "@mui/material";
import { FC, useState } from "react";
import { ControllerFieldState, ControllerRenderProps } from "react-hook-form";

interface TimeZoneProps {
  field: ControllerRenderProps;
  fieldState: ControllerFieldState;
  opts: any;
  disabled?: boolean;
}
const TimeZone: FC<TimeZoneProps> = ({ field, fieldState, opts, disabled = false }) => {
  const [inputValue, setInputValue] = useState("");
  const [timezone, setTimezone] = useState<string | null>(field.value);
  const [tzOpen, setTZOpen] = useState(false);

  const onOpen = () => setTZOpen(true);
  const onTZClose = (event: any) => {
    if (
      (event?.relatedTarget as HTMLElement)?.className?.includes?.("block-close") ||
      (event?.target as HTMLElement)?.parentElement?.className?.includes?.("block-close") ||
      (event?.target as HTMLElement)?.className?.includes?.("block-close")
    ) {
    } else {
      setTZOpen(false);
    }
  };

  // const onFocus = () => {
  //   const filterValue = opts.find((o) => o.value === field.value);
  //   setTimezone(filterValue);
  //   field.onChange(filterValue);
  // };

  return (
    <div style={{ marginTop: 0, marginBottom: 0, padding: 0 }}>
      <p
        style={{
          fontSize: 12,
          marginTop: 0,
          marginBottom: 0,
        }}
      >
        Timezone
      </p>
      <Autocomplete
        {...field}
        open={tzOpen}
        onOpen={onOpen}
        onClose={onTZClose}
        getOptionLabel={(option) => (typeof option === "string" ? option : String(option))}
        blurOnSelect={false}
        clearOnBlur={false}
        multiple={false}
        limitTags={1}
        size={"small"}
        disabled={disabled}
        isOptionEqualToValue={(o, v) => o === v}
        options={opts}
        inputValue={inputValue}
        onInputChange={(_, value) => setInputValue(value)}
        renderInput={(params) => (
          <TextField
            {...params}
            margin="normal"
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              type: "search",
              style: {
                height: 40,
                borderRadius: 8,
              },
            }}
            sx={{ marginTop: 0, marginBottom: 0 }}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            size={"small"}
            placeholder={field.value?.length ? "" : "Please select"}
          />
        )}
        onChange={(_e: any, value) => {
          setTimezone(value);
          field.onChange(value);
        }}
        value={timezone}
      />
    </div>
  );
};

export default TimeZone;
